import React from 'react'
import {Box, CircularProgress} from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined'
import RoundActionButtonNew, {getRoundActionColor} from './RoundActionButtonNew'

// One-tap answer for a reminder still awaiting a response: a round "not taken" and a round
// "taken" button, replacing a text link. `onDeny` fires immediately (CANCELLED has nothing left
// to ask — RF4/RF1.2), `onConfirm` instead opens the follow-up asking when/where (RF5.1 scenario
// 3 vs 4), since a COMPLETED answer may still need a time and a body part.
// `onReschedule` adds the RF4.5 "move next dose" action in the same round style, so the three
// actions of a row read as one set.
interface QuickAnswerButtonsNewProps {
  onDeny: () => void
  onConfirm: () => void
  onReschedule?: () => void
  denyLoading?: boolean
}

export default function QuickAnswerButtonsNew({
  onDeny,
  onConfirm,
  onReschedule,
  denyLoading
}: QuickAnswerButtonsNewProps): JSX.Element {
  return (
    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
      <RoundActionButtonNew tone="deny" label="Segna come non assunta" onClick={onDeny} disabled={denyLoading}>
        {denyLoading ? <CircularProgress size={16} sx={{color: getRoundActionColor('deny')}} /> : <CloseIcon />}
      </RoundActionButtonNew>
      <RoundActionButtonNew tone="confirm" label="Segna come assunta" onClick={onConfirm} disabled={denyLoading}>
        <CheckIcon />
      </RoundActionButtonNew>
      {onReschedule && (
        <RoundActionButtonNew tone="neutral" label="Sposta prossima assunzione" onClick={onReschedule}>
          <UpdateOutlinedIcon />
        </RoundActionButtonNew>
      )}
    </Box>
  )
}
